/**
 * 仪表板数据服务
 */
import type { DashboardData } from '../types/dashboard';
import { generateDashboardData } from './mockData';

// Mock 仪表板数据缓存
let cachedDashboardData: DashboardData | null = null;
let cacheTimestamp: number = 0;
const CACHE_DURATION = 15 * 60 * 1000; // 15 分钟缓存（PRD 要求）

// 获取仪表板指标数据
export async function getDashboardMetrics(): Promise<DashboardData> {
  // 模拟 API 延迟
  await new Promise(resolve => setTimeout(resolve, 800));

  // 检查缓存
  const now = Date.now();
  if (cachedDashboardData && (now - cacheTimestamp) < CACHE_DURATION) {
    return cachedDashboardData;
  }

  // 生成新数据
  const data = generateDashboardData();
  cachedDashboardData = data;
  cacheTimestamp = now;

  return data;
}

// 刷新仪表板数据（清除缓存）
export async function refreshDashboardMetrics(): Promise<DashboardData> {
  cachedDashboardData = null;
  return getDashboardMetrics();
}
